export default __webpack_public_path__ + "static/media/logo-desktop.8127b307.png";